import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the plans state domain
 */

const selectPlansDomain = state => state.plans || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Plans
 */

const selectPlansData = () =>
  createSelector(
    selectPlansDomain,
    substate => substate.plansData,
  );

const selectPlansList = () =>
  createSelector(
    selectPlansDomain,
    substate => substate.plansList,
  );

const selectPlansLoading = () =>
  createSelector(
    selectPlansDomain,
    substate => substate.loading,
  );

const selectPlansError = () =>
  createSelector(
    selectPlansDomain,
    substate => substate.error,
  );

const selectPlansDeleteSuccessful = () =>
  createSelector(
    selectPlansDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectPlansDomain,
  selectPlansLoading,
  selectPlansError,
  selectPlansDeleteSuccessful,
  selectPlansData,
  selectPlansList,
};
